"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultExpectedValue = exports.arrayExpectedValueDataDefaults = void 0;
exports.arrayExpectedValueDataDefaults = {
    minItems: 0,
    maxItems: 0,
};
const getDefaultExpectedValue = (typeId) => {
    if (typeId === "object") {
        return {
            typeId: "object",
            properties: [],
        };
    }
    else if (typeId === "array") {
        return {
            typeId: "array",
            itemIds: [],
            infinity: true,
            ...exports.arrayExpectedValueDataDefaults,
        };
    }
    return { typeId };
};
exports.getDefaultExpectedValue = getDefaultExpectedValue;
